import { browserName } from 'react-device-detect';

type TBrowserType = 'Chrome' | 'Firefox' | 'Opera' | 'Safari' | 'Mobile Safari' | 'Yandex' | 'Edge';

export function getBrowserName() {
    return browserName as TBrowserType;
}
